import React from 'react'

function TransportActivitiesLice() {
    return (
        <div style={{ padding: '50px', fontSize: '10px' }}>
            <h1>
                تقدم هذه الخدمة للشركات الدولية التي ترغب في تقديم 
                <br />
                خدمات النقل العام في المملكة. وتوفر المملكة عدة مجالات
                <br />
                يمكن الاستثمار فيها في خدمات
                </h1>
        </div>
  )
}

export default TransportActivitiesLice